const counterparties = state => state.counterparties
const isLoading = state => state.isLoading
const hasError = state => state.error !== null
const error = state => state.error
const hasCounterparties = state => state.counterparties.length > 0

export default {
  counterparties, isLoading, hasError, error, hasCounterparties,
}
